import { createSlice } from "@reduxjs/toolkit";

const initialState={
    data:"",
 
}

const TranscriptionSlice=createSlice({
    name:"transcription",
    initialState:initialState,
    reducers:{

        transcription:(state,action)=>{
            state.data=action.payload
        }

    }
})

export default TranscriptionSlice.reducer;

export const{transcription}=TranscriptionSlice.actions;
